import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/gtm';

export const useGTM = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(
      location.pathname,
      document.title
    );
  }, [location]);
};